// extracted by mini-css-extract-plugin
export default {"modalBody":"SelectIndexerFlagsModalContent-modalBody-sne5e ModalBody-modalBody-RVK6D"};